var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.16L2.84 5.75l3-3h-3.2v-2h6.65v6.63h-2V4.12"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzAwNmVhZCI+CiAgICA8cGF0aCBkPSJNNC4yNSA3LjE2TDIuODQgNS43NWwzLTNoLTMuMnYtMmg2LjY1djYuNjNoLTJWNC4xMiIgZmlsbD0iIzAwNmVhZCIgLz4KPC9zdmc+Cg==";
export { SvgExternalArrow as ReactComponent };